import { HttpError } from '../../../src/business/httpError';
import { AxiosError } from 'axios';
import { portal } from '../../assets/plugins/axios/axios';

class PostService {
  public bookmark = async (postId: number) => {
    try {
      await portal.post('?method=posts.bookmark', { postId });
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };

  public unbookmark = async (postId: number) => {
    try {
      await portal.post('?method=posts.unbookmark', { postId });
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };
}

export const postService = new PostService();
